var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoalIco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 852.51 682.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#344d5f;stroke-linecap:round;stroke-linejoin:round;stroke-width:34px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_2",
    "data-name": "Warstwa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1-2",
    "data-name": "Warstwa 1"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "808.05 665.9 736.63 665.9 89.1 665.9 17 665.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M238.11,433.12c59.74,0,108.49,48.76,108.49,108.5S297.85,650.11,238.11,650.11s-108.5-48.75-108.5-108.49,48.76-108.5,108.5-108.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M598.61,437.93c59.74,0,108.5,48.75,108.5,108.49s-48.76,108.5-108.5,108.5-108.49-48.76-108.49-108.5,48.75-108.49,108.49-108.49Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 352.78,
    y1: 503.85,
    x2: 496.98,
    y2: 506.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 184.55,
    y1: 431.06,
    x2: 80.86,
    y2: 234.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 685.13,
    y1: 457.16,
    x2: 788.82,
    y2: 240.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 25.93,
    y1: 214.76,
    x2: 835.51,
    y2: 220.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 76.05,
    y1: 199.65,
    x2: 69.87,
    y2: 159.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 132.36,
    y1: 139.23,
    x2: 69.19,
    y2: 150.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 152.27,
    y1: 69.87,
    x2: 134.42,
    y2: 139.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 219.57,
    y1: 75.37,
    x2: 152.96,
    y2: 67.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 305.4,
    y1: 19.06,
    x2: 222.32,
    y2: 72.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 375.44,
    y1: 34.85,
    x2: 306.09,
    y2: 17.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 442.05,
    y1: 17.69,
    x2: 375.44,
    y2: 34.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 536.12,
    y1: 69.19,
    x2: 446.86,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 608.91,
    y1: 34.17,
    x2: 536.81,
    y2: 69.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 685.13,
    y1: 57.51,
    x2: 606.85,
    y2: 34.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 735.95,
    y1: 98.03,
    x2: 692.69,
    y2: 60.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 768.22,
    y1: 172.19,
    x2: 735.95,
    y2: 96.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 800.49,
    y1: 205.83,
    x2: 766.16,
    y2: 170.81
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoalIco);
export default __webpack_public_path__ + "static/media/coal-ico.d1d8ef9a.svg";
export { ForwardRef as ReactComponent };